import { useParams } from "react-router-dom";
import { useEffect, useRef } from "react";
import { Box } from "@mui/material";

// Local imports
import { PracticeVideoCard } from "./video_page/PracticeVideo";
import { fetchSingAlongVideo } from "../api/course-service";
import LoadingIcon from "./loading/LoadingIcon";
import Error from './Error';
import { ErrorState } from "../scripts/errorHandling";
import { LoadedDataState, useLoadedData } from "../scripts/loadedData/loadedData";
import { useVideoManager } from "../scripts/video/videoManager";

const SingAlong = () => {
    const { id } = useParams();

    const [ video, manageVideo ] = useLoadedData();

    const videoManager = useVideoManager(null);
    const videoState = videoManager.state.current;
    const playRef = useRef(null);

    useEffect(() => {
        // Ignore responses for a previous id if the id changes mid-request
        let ignore = false;
        manageVideo.setWorking();
        fetchSingAlongVideo(id).then(
            data  => { if (!ignore) data ? manageVideo.setSuccess(data) : manageVideo.setFailure(ErrorState.NO_VIDEO_DATA) },
            error => { if (!ignore) manageVideo.setFailure(ErrorState.NO_VIDEO_DATA, error) },
        );
        return () => { ignore = true; };
    // manageVideo is a new object every render, so including it would refetch in a loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    if (video.state === LoadedDataState.FAILURE) {
        return <Error message={ video.error?.cause?.message ?? "Error fetching video" } />
    }

    if (video.state !== LoadedDataState.SUCCESS) {
        return <LoadingIcon />
    }

    return (
        <div>
            <h1>Sing along: {video.value.name}</h1>
            <Box sx={{
                width: '100%',
                maxWidth: 1000,
                mx: 'auto',
                aspectRatio: '16 / 9',
                '& > .MuiCard-root': { height: '100%' },
            }}>
                <PracticeVideoCard
                    videoContent = { video }
                    videoState   = { videoState }
                    videoManager = { videoManager }
                    playRef      = { playRef }
                    isRecording  = { false }
                    isComplete   = { videoState.isCompleted }
                    playbackOnly
                />
            </Box>
        </div>
    )
}

export default SingAlong;